module.exports = __webpack_public_path__ + "static/media/Royal Guard.36e8b917.jpg";